import './chartblock.less'

import {m} from '@codeurs/front'
import {FunctionComponent, useEffect, useState} from 'react'
import {style} from 'util/style'
import {Block} from 'views/blocks/blocks'

const styles = style('chartblock')

export type ChartBlockType = {
	embed: string
	embed_script: string
	embed_width?: number
}

export const ChartBlock: FunctionComponent<ChartBlockType> = ({
	embed,
	embed_script,
	embed_width
}) => {
	const [loading, setLoading] = useState(true)
	if (!embed_width && window.innerWidth < 768) embed_width = 700

	useEffect(() => {
		// Append scripts in document head
		const loadScripts = []
		const foundLoadScripts = embed_script.match(/<script[^>]*src=[^>]*>/g)
		if (foundLoadScripts && foundLoadScripts.length) {
			const knownSources = []
			for (let i = 0; i < document.scripts.length; i++) {
				knownSources.push(document.scripts.item(i).getAttribute('src'))
			}
			foundLoadScripts.forEach(ls => {
				const scriptSrc = ls.replace(/(^.*src=['"])|(['"].+?$)/g, '')
				if (knownSources.indexOf(scriptSrc) < 0) {
					const script = document.createElement('script')
					script.src = scriptSrc
					script.type = 'text/javascript'
					script.async = false
					document.head.appendChild(script)
					loadScripts.push(script)
				}
			})
		}

		// Run code between <script> tags
		const addWait = loadScripts.length ? 3000 : 0
		let runScripts = ''
		const foundRunScripts = embed_script.match(/<script>[\S\s]+?<\/script>/g)
		if (foundRunScripts && foundRunScripts.length) {
			foundRunScripts.forEach(rs => {
				runScripts += rs.replace('<script>', '').replace('</script>', '')
			})
		}

		let tries = 0
		const runCode = () => {
			tries++
			if (tries > 3) return
			setTimeout(() => {
				if (runScripts.length) {
					try {
						eval(runScripts)
					} catch (e) {
						console.log('chartblock error: ' + e.message)
						runCode()
					}
				}
			}, addWait)
		}
		runCode()

		setTimeout(() => {
			setLoading(false)
		}, 1500 + addWait)

		// Remove appended scripts in document head
		return () => {
			loadScripts.forEach(script => {
				document.head.removeChild(script)
			})
		}
	}, [])

	// Create initial HTML with div and svg
	let fallBackContainer = embed ? embed.replace(/\s/g, ' ') : ''
	const foundDivs = embed_script.match(/<div[^>]*id=[^>]*>/g)
	if (foundDivs && foundDivs.length) {
		foundDivs.reverse().forEach(div => {
			const cleanDiv = div.replace('/>', '>')
			fallBackContainer = cleanDiv + fallBackContainer + '</div>'
		})
	}
	if (embed_width) {
		const widthString = `  style="width: 100%; max-width: ${embed_width}px; margin: 0 auto;"`
		const fullWidthString = `  style="width: 100%; margin: 0 auto;"`
		fallBackContainer = fallBackContainer
			.replace('<svg', `<svg${widthString}`)
			.replace('<div ', `<div${fullWidthString} `)
	}

	return (
		<Block class={styles}>
			<div
				class={styles('iframe').mod({loading})}
				style={embed_width ? {maxWidth: embed_width + 'px'} : {}}
				dangerouslySetInnerHTML={{__html: fallBackContainer}}
			></div>
			{loading && <div class={styles('loader')}></div>}
		</Block>
	)
}
